import { PreloadedQuery } from "react-relay";

import { pricingPageRelayQuery } from "@/__generated_contentful__/pricingPageRelayQuery.graphql";
import { PricingContentContextProviderRelay } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content-gql.ts";
import { UserLocale } from "@/utils/useGeoCurrency.ts";

import { AppPricingData } from "../../../../contentful/index.tsx";
import { SoftwareGuardPricingPageTemplate } from "../../../../templates/software/guard/pricing/software-guard-pricing-page/src";

export type SoftwareGuardPricingPageProps = {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
    queryRef?: PreloadedQuery<pricingPageRelayQuery>;
};

export const SoftwareGuardPricingPage = ({
    pricing,
    countryCode,
    pricingContent,
    queryRef
}: SoftwareGuardPricingPageProps) => {
    return (
        <PricingContentContextProviderRelay
            productId="atlassian-access"
            pricingContent={pricingContent}
            queryRef={queryRef}
        >
            <div data-testid="guard-pricing-page">
                <SoftwareGuardPricingPageTemplate
                    pricing={pricing}
                    countryCode={countryCode}
                />
            </div>
        </PricingContentContextProviderRelay>
    );
};
